import {Typography} from '@mui/material'
import Icon from '@mdi/react'
import {mdiAccountEdit, mdiAccountPlus} from '@mdi/js'
import LayoutContainer from 'src/components/layouts/LayoutContainer/LayoutContainer'
import TabsCustom from 'src/components/layouts/TabsLayout/TabsLayout'
import {PATHS} from 'src/constants/constants'
import PatientEnrollmentContent from '../patientEnrollment/PatientEnrollment'
import DigitalEnrollmentContent from '../digitalEnrollment/DigitalEnrollment'
import {useAppSelector} from 'src/hooks'

const EnrollmentHub = () => {
  const pspConfig = useAppSelector(state => state.pspConfigReducer.data)

  const showPatientEnrollment = pspConfig.sidebarItems?.patientEnrollment?.show
  const showDigitalEnrollment = pspConfig.sidebarItems?.digitalEnrollment?.show

  const TABS = [
    {
      id: 'patientEnrollment',
      icon: <Icon path={mdiAccountEdit} size={1} />,
      label: <Typography style={{fontSize: 12, fontWeight: 600}}>{pspConfig.sidebarItems?.patientEnrollment?.label}</Typography>
    },
    {
      id: 'digitalEnrollment',
      icon: <Icon path={mdiAccountPlus} size={1} />,
      label: <Typography style={{fontSize: 12, fontWeight: 600}}>{pspConfig.sidebarItems?.digitalEnrollment?.label}</Typography>
    }
  ].filter((tab) => {
    if (tab.id === 'patientEnrollment') return showPatientEnrollment
    if (tab.id === 'digitalEnrollment') return showDigitalEnrollment
    return false
  })

  const CONTENT = [
    <PatientEnrollmentContent key='patientEnrollment' />,
    <DigitalEnrollmentContent key='digitalEnrollment' />
  ].filter((content) => {
    if (content.key === 'patientEnrollment') return showPatientEnrollment
    if (content.key === 'digitalEnrollment') return showDigitalEnrollment
    return false
  })

  return (
    <LayoutContainer breadcrumbs={[{label: pspConfig.sidebarItems?.enrollmentHub?.label, href: PATHS.ENROLLMENT_HUB}]}>
      <TabsCustom
        contents={CONTENT}
        tabs={TABS}
      />
    </LayoutContainer>
  )
}

export default EnrollmentHub
